/** レース画面の骨組み（docs/06_ui-ux.md 2 章）。CSS Grid の領域名で配置する */
export interface Layout {
  root: HTMLElement;
  topBar: HTMLElement;
  view: HTMLElement;
  canvasHost: HTMLElement;
  labelHost: HTMLElement;
  hud: HTMLElement;
  weather: HTMLElement;
  log: HTMLElement;
  panel: HTMLElement;
  overlay: HTMLElement;
}

export function createLayout(parent: HTMLElement): Layout {
  const root = document.createElement('div');
  root.className = 'app';
  root.innerHTML = `
    <header class="topbar"></header>
    <main class="view">
      <div class="view__canvas"></div>
      <div class="view__labels"></div>
      <div class="view__hud"></div>
    </main>
    <section class="weather"></section>
    <aside class="log"></aside>
    <footer class="panel"></footer>
    <div class="overlay"></div>
  `;
  parent.appendChild(root);
  const q = (sel: string): HTMLElement => root.querySelector(sel) as HTMLElement;
  return {
    root,
    topBar: q('.topbar'),
    view: q('.view'),
    canvasHost: q('.view__canvas'),
    labelHost: q('.view__labels'),
    hud: q('.view__hud'),
    weather: q('.weather'),
    log: q('.log'),
    panel: q('.panel'),
    overlay: q('.overlay'),
  };
}

/** テキストを安全に入れた要素を作る */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  text?: string,
): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  if (className) e.className = className;
  if (text !== undefined) e.textContent = text;
  return e;
}
